import React, { useState } from "react";
import { Card, Table, Form, Dropdown } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import EditProjectModal from "../../components/modals/projects/EditProjectModal";
import DeleteProjectModal from "../../components/modals/projects/DeleteProjectModal";
import ProjectHeader from "../../components/projects/ProjectHeader";
import { useProjects } from "../../components/context/ProjectContext";

const ProjectList = () => {
  const { projects, deleteProject } = useProjects();
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(10);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const handleEdit = (project) => {
    setSelectedProject(project);
    setShowEdit(true);
  };

  const handleDelete = (project) => {
    setSelectedProject(project);
    setShowDelete(true);
  };

  // 🔍 SEARCH FILTER
  const filteredData = projects.filter(
    (item) =>
      item.name.toLowerCase().includes(search.toLowerCase()) ||
      item.id.toLowerCase().includes(search.toLowerCase()),
  );

  const handleConfirmDelete = () => {
    if (selectedProject) {
      deleteProject(selectedProject.id);
      setShowDelete(false);
      setSelectedProject(null);
    }
  };

  return (
    <div style={{ background: "#f8f9fa" }} className="h-100">
      <ProjectHeader />
      <div className="container-fluid p-3">
        <Card className="projectlist-card">
          {/* HEADER */}
          <div className="card-header d-flex justify-content-between flex-wrap">
            <h5>Project List</h5>

            <div className="d-flex gap-2">
              <Dropdown>
                <Dropdown.Toggle className="btn btn-white   text-dark bg-transparent">
                  Select Status
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item>Active</Dropdown.Item>
                  <Dropdown.Item>Inactive</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <Dropdown>
                <Dropdown.Toggle className="btn btn-white   text-dark bg-transparent ">
                  Sort By : Last 7 Days
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item>Recently Added</Dropdown.Item>
                  <Dropdown.Item>Ascending</Dropdown.Item>
                  <Dropdown.Item>Descending</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          {/* FILTER BAR */}
          <div className="p-3 d-flex justify-content-between flex-wrap gap-2">
            <div className="d-flex align-items-center gap-2">
              <span>Row Per Page</span>
              <Form.Select
                style={{ width: "80px" }}
                value={rows}
                onChange={(e) => setRows(e.target.value)}
              >
                <option>5</option>
                <option>10</option>
                <option>20</option>
              </Form.Select>
              <span>Entries</span>
            </div>

            <Form.Control
              placeholder="Search"
              style={{ maxWidth: "250px" }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* TABLE */}
          <div className="table-responsive">
            <Table className="mb-0 align-middle">
              <thead className="bg-light">
                <tr>
                  <th></th>
                  <th>Project ID</th>
                  <th>Project Name</th>
                  <th>Leader</th>
                  <th>Deadline</th>
                  <th>Priority</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {filteredData.slice(0, rows).map((item, i) => (
                  <tr key={i}>
                    <td>
                      <Form.Check />
                    </td>

                    <td>{item.id}</td>

                    <td className="fw-medium">{item.name}</td>

                    {/* LEADER */}
                    <td>
                      <div className="d-flex align-items-center">
                        <img src={item.img} alt="" className="avatar me-2" />
                        {item.leader}
                      </div>
                    </td>

                    <td>{item.date}</td>

                    {/* PRIORITY */}
                    <td>
                      <span
                        className={`badge priority-${item.priority.toLowerCase()}`}
                      >
                        ● {item.priority}
                      </span>
                    </td>

                    {/* STATUS */}
                    <td>
                      <span
                        className={`badge ${
                          item.status === "Active" ? "bg-success" : "bg-danger"
                        }`}
                      >
                        ● {item.status}
                      </span>
                    </td>

                    {/* ACTIONS */}
                    <td>
                      <FaEdit
                        onClick={() => handleEdit(item)}
                        className="me-2 cursor"
                      />
                      <FaTrash
                        onClick={() => handleDelete(item)}
                        className="cursor text-danger"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <EditProjectModal
            show={showEdit}
            handleClose={() => setShowEdit(false)}
            project={selectedProject}
          />

          <DeleteProjectModal
            show={showDelete}
            handleClose={() => setShowDelete(false)}
            project={selectedProject}
            onConfirmDelete={handleConfirmDelete}
          />
        </Card>
        <style>
          {`
          .projectlist-card{
border-radius:5px;
border:1px solid #e5e7eb;
background:#ffffff;
          }
.card-header{
background:#ffffff;
}
          .avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

/* Priority Colors */
.priority-high {
  color: red;
  background: #ffe5e5;
  padding: 5px 10px;
  border-radius: 6px;
}

.priority-medium {
  color: orange;
  background: #fff4e5;
  padding: 5px 10px;
  border-radius: 6px;
}

.priority-low {
  color: green;
  background: #e6fff2;
  padding: 5px 10px;
  border-radius: 6px;
}

/* Cursor */
.cursor {
  cursor: pointer;
}

/* Responsive */
@media (max-width: 768px) {
  .card-header {
    flex-direction: column;
    gap: 10px;
  }
}`}
        </style>
      </div>
    </div>
  );
};

export default ProjectList;
